/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Already_ExistsInputs */

const en_us2_account_already_exists = /** @type {(inputs: Account_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An account with that email already exists.`)
};

const pt_br2_account_already_exists = /** @type {(inputs: Account_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já existe uma conta com esse e-mail.`)
};

const es_419_account_already_exists = /** @type {(inputs: Account_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya existe una cuenta con ese correo.`)
};

const pt_pt2_account_already_exists = /** @type {(inputs: Account_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já existe uma conta com esse e-mail.`)
};

const fr_fr2_account_already_exists = /** @type {(inputs: Account_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un compte existe déjà avec cet e-mail.`)
};

const de_de2_account_already_exists = /** @type {(inputs: Account_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es gibt bereits ein Konto mit dieser E-Mail.`)
};

const it_it2_account_already_exists = /** @type {(inputs: Account_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esiste già un account con questa email.`)
};

/**
* | output |
* | --- |
* | "An account with that email already exists." |
*
* @param {Account_Already_ExistsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const account_already_exists = /** @type {((inputs?: Account_Already_ExistsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Already_ExistsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_account_already_exists(inputs)
	if (locale === "es-419") return es_419_account_already_exists(inputs)
	if (locale === "pt-PT") return pt_pt2_account_already_exists(inputs)
	if (locale === "fr-FR") return fr_fr2_account_already_exists(inputs)
	if (locale === "de-DE") return de_de2_account_already_exists(inputs)
	if (locale === "it-IT") return it_it2_account_already_exists(inputs)
	return en_us2_account_already_exists(inputs)
});
export { account_already_exists as "account.already_exists" }